// extracted by mini-css-extract-plugin
export default {"icon":"AddTaskForm_icon__CAJbf"};